import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
/** A new number is the one thing a clone cannot inherit; the name may be kept or replaced. */
export const clonePartInputSchema = z.object({
    sourcePartId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    num: z
        .string()
        .trim()
        .min(1, `${PART_CONSTRAINTS.num.label} is required.`)
        .max(PART_CONSTRAINTS.num.maxLength),
    name: z.string().trim().max(PART_CONSTRAINTS.name.maxLength).optional().nullable(),
    // Each defaults to copying: an older client that omits them gets the full clone it always did.
    copyVendors: z
        .boolean()
        .nullish()
        .transform((value) => value ?? true),
    copyStockSetup: z
        .boolean()
        .nullish()
        .transform((value) => value ?? true),
    copyCosting: z
        .boolean()
        .nullish()
        .transform((value) => value ?? true),
    copySpecifications: z
        .boolean()
        .nullish()
        .transform((value) => value ?? true),
});
//# sourceMappingURL=clone-input.js.map